import { UrlConstants } from "../url.constants";
export class ApiPropertyValuationValuationRollConstants {
    static URL = UrlConstants.API_V2 + "PropertyValuationValuationRoll";
    static FUNCTION_DELETE_MULTIPLE_VALUATION_ROLLS = "DeleteMultipleValuationRolls";
    static FUNCTION_GENERATE_ROLL_TYPE = "GenerateRollType";
}
